export default __webpack_public_path__ + "static/media/Glodani 1.52d4349b.jpg";